<script setup lang="ts">
  import { IconLocked } from '@gat-ship/icons'
  import {
    Button,
    Modal,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalHeaderDescription,
    ModalHeaderTitle
  } from '@gat-ship/vue-components'
  import { ref, useTemplateRef } from 'vue'
  import { accessCodes } from '@gat-ship/types'
  import FormCreateSupportSession, {
    type CreateSupportSessionFormProps
  } from '../forms/FormCreateSupportSession.vue'
  import { useUser } from '@gat-ship/user'

  const user = useUser()

  const form = useTemplateRef('form')
  const isOpen = defineModel<boolean>('open', { default: false })

  const formProps = ref<CreateSupportSessionFormProps>({
    supportSession: undefined
  })

  function showModal(props: CreateSupportSessionFormProps) {
    isOpen.value = true
    formProps.value = props
  }

  defineExpose({
    showModal
  })
</script>
<template>
  <Modal v-model:open="isOpen">
    <ModalHeader>
      <ModalHeaderTitle> Grant Support Access </ModalHeaderTitle>
      <ModalHeaderDescription>
        Send a request to enable Gatship support to access your tenant.
      </ModalHeaderDescription>
    </ModalHeader>
    <ModalContent>
      <div
        v-if="
          !user.hasPermission(accessCodes.system.support.createSupportSession)
        "
        class="flex items-center gap-2"
      >
        <IconLocked class="size-6 shrink-0" />
        <div class="flex flex-col gap-4">
          <div class="text-muted-foreground text-sm">
            You do not have access to this feature. Please contact your
            administrator to request access.
          </div>
        </div>
      </div>
      <FormCreateSupportSession
        v-else
        ref="form"
        v-bind="formProps"
        @saved="isOpen = false"
      />
    </ModalContent>
    <ModalFooter>
      <Button
        v-if="
          user.hasPermission(accessCodes.system.support.createSupportSession)
        "
        data-testid="request-support-ok-btn"
        :disabled="form?.isSubmitting"
        @click="form?.submit()"
      >
        Request Support
      </Button>
      <Button variant="ghost" @click="isOpen = false">
        {{
          user.hasPermission(accessCodes.system.support.createSupportSession)
            ? 'Cancel'
            : 'Close'
        }}
      </Button>
    </ModalFooter>
  </Modal>
</template>
